/**
 * Sorts regions by their path depth (shallowest to deepest).
 * This ensures regions are in the correct hierarchical order for breadcrumbs.
 *
 * @param regions - Array of regions with optional path property
 * @returns Sorted array of regions
 */
export function sortRegionsByPathDepth<T extends { path?: string | null }>(
  regions: T[]
): T[] {
  return [...regions].sort((a, b) => {
    const aDepth = a.path ? a.path.split('/').length : 0;
    const bDepth = b.path ? b.path.split('/').length : 0;
    return aDepth - bDepth;
  });
}
